export default {
    created_at: "일시",
    worker_baromoney_type_detail: "항목",
    transaction_baromoney: "금액",
    balance_baromoney: "라이더 바로머니 잔액",
    worker_baromoney_memo: "메모",
    order_id: "접수번호",
    created_by: "처리자",
    hub_name: "허브명",
    employee_type: "고용형태",
    salary_type: "보수지급방식",
    hub_employee_number: "사번",
    worker_code: "라이더 코드",
    worker_name: "라이더명",
    content: "항목",
    employee_type_option: {
        full_time: "근로계약(정규직포함)",
        special: "특수고용직",
        hub_owner: "사업주(허브장 본인)",
    },
    salary_type_option: {
        fixed_pay: "고정급(출금제한)",
        performance_pay: "실적급(자율출금)",
    },
};
